import { render, staticRenderFns } from "./detail_mob.vue?vue&type=template&id=924415c6&scoped=true"
import script from "./detail_mob.vue?vue&type=script&lang=js"
export * from "./detail_mob.vue?vue&type=script&lang=js"
import style0 from "./detail_mob.vue?vue&type=style&index=0&id=924415c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924415c6",
  null
  
)

export default component.exports